import React from 'react';
import { List } from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';
import {
  Button,
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import SocialShare from '../../../../components/SocialShare';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_HUGE,
} from '../../../../config/constants';

import './style.scss';

const NodeArticleChapterDialog = ({ entity, title, closeDialog }) => {
  const ArticleDialog = entity.toJS();

  const image = ArticleDialog.field_image[0]?.styles;
  const summary = ArticleDialog.body[0]?.summary;
  const body = ArticleDialog.body[0]?.processed;

  const { t } = useTranslation();

  return (
    <article className="NodeArticleChapterDialog">
      <h2 className="NodeArticleChapterDialog__title">{title}</h2>
      <SocialShare />
      {summary && (
        <p className="NodeArticleChapterDialog__summary">
          {summary}
        </p>
      )}
      {image && (
        <div className="NodeArticleChapterDialog__heroimage">
          <Image
            lazyload={false}
            includeWebP
            src={{
              [SCREEN_MOBILE]: image.ratio_4_3_sm,
              [SCREEN_TABLET]: image.ratio_4_3_md,
              [SCREEN_HUGE]: image.ratio_4_3_xl,
            }}
          />
        </div>
      )}
      {body && (
        <div className="NodeArticleChapterDialog__body">
          <WysiwygField
            property="schema:text"
            html={body}
          />
        </div>
      )}
      {entity.get('field_paragraphs', List()).size > 0 && (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            return (
              <Paragraph
                key={`paragraph:${id}`}
                id={id}
                entity={paragraph.get('entity')}
                lazyload={false}
              />
            );
          })}
        </div>
      )}
      <Button
        className="Button Button--secondary NodeArticleChapterDialog__closebutton"
        onClick={closeDialog}
      >
        {t('article.close')} <span className="icon icon-cross icon-variant-0" />
      </Button>
    </article>
  );
};

export default NodeArticleChapterDialog;
